module.exports = __webpack_public_path__ + "img/oran_10kl.6f59c1cf.jpg";